export default __webpack_public_path__ + "static/media/intro3.37382b0f.mp3";